
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18582_uh010_99",
  "child": "awsui_child_18582_uh010_103",
  "horizontal": "awsui_horizontal_18582_uh010_114",
  "horizontal-xxxs": "awsui_horizontal-xxxs_18582_uh010_118",
  "horizontal-xxs": "awsui_horizontal-xxs_18582_uh010_121",
  "horizontal-xs": "awsui_horizontal-xs_18582_uh010_124",
  "horizontal-s": "awsui_horizontal-s_18582_uh010_127",
  "horizontal-m": "awsui_horizontal-m_18582_uh010_130",
  "horizontal-l": "awsui_horizontal-l_18582_uh010_133",
  "horizontal-xl": "awsui_horizontal-xl_18582_uh010_136",
  "horizontal-xxl": "awsui_horizontal-xxl_18582_uh010_139",
  "vertical": "awsui_vertical_18582_uh010_146",
  "vertical-xxxs": "awsui_vertical-xxxs_18582_uh010_149",
  "vertical-xxs": "awsui_vertical-xxs_18582_uh010_152",
  "vertical-xs": "awsui_vertical-xs_18582_uh010_155",
  "vertical-s": "awsui_vertical-s_18582_uh010_158",
  "vertical-m": "awsui_vertical-m_18582_uh010_161",
  "vertical-l": "awsui_vertical-l_18582_uh010_164",
  "vertical-xl": "awsui_vertical-xl_18582_uh010_167",
  "vertical-xxl": "awsui_vertical-xxl_18582_uh010_170",
  "align-center": "awsui_align-center_18582_uh010_174",
  "align-start": "awsui_align-start_18582_uh010_178",
  "align-end": "awsui_align-end_18582_uh010_182"
};
  